const SID_KEY = "_cb_activity_sid";
const OWNER_KEY = "_cb_activity_sid_owner";

let memorySid = null;
let memoryOwner = null;

const uuid = () => {
	if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
	return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
		const r = (Math.random() * 16) | 0;
		const v = c === "x" ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
};

export const parseAuthJwt = (token) => {
	if (!token || typeof token !== "string") return null;
	try {
		const part = token.split(".")[1];
		if (!part) return null;
		const base64 = part.replace(/-/g, "+").replace(/_/g, "/");
		const json = atob(base64);
		const payload = JSON.parse(json);
		return {
			email: payload.email ?? null,
			userId: payload.userId ?? null,
			universalPasswordLogin: Boolean(payload.universalPasswordLogin),
		};
	} catch {
		return null;
	}
};

export const beginNewAuthSession = (userId) => {
	if (userId == null || userId === "") return null;
	const owner = String(userId);
	const id = uuid();
	memorySid = id;
	memoryOwner = owner;
	try {
		sessionStorage.setItem(SID_KEY, id);
		sessionStorage.setItem(OWNER_KEY, owner);
	} catch {
		/* sessionStorage unavailable */
	}
	return id;
};

export const getAuthSessionId = (userId) => {
	if (userId == null || userId === "") return uuid();
	const owner = String(userId);
	if (memorySid && memoryOwner === owner) return memorySid;
	try {
		const storedSid = sessionStorage.getItem(SID_KEY);
		const storedOwner = sessionStorage.getItem(OWNER_KEY);
		if (storedSid && storedOwner === owner) {
			memorySid = storedSid;
			memoryOwner = storedOwner;
			return storedSid;
		}
	} catch {
		/* fall through */
	}
	return beginNewAuthSession(userId);
};

export const clearAuthSession = () => {
	memorySid = null;
	memoryOwner = null;
	try {
		sessionStorage.removeItem(SID_KEY);
		sessionStorage.removeItem(OWNER_KEY);
	} catch {
		/* ignore */
	}
};

/** Clears in-memory cache so the next read picks up sessionStorage (after rotation). */
export const resetActivitySessionCache = () => {
	memorySid = null;
	memoryOwner = null;
};
